import React, { useState } from 'react';
import { PopupBody, PopupContainer, PopupOverlay, CloseButton, PopupHeader, PopupFooter, Button, DivSpinner, DivLoaderContainer, PSelectedRow, DivSummaryResult, SpanResultLine, SummaryHeader, DivResultContent, UserInfoColumn, CommentList, ErrorMessage, StatusBadge } from './modal.styled.js'
import CheckTrue from '../../assets/checkTrue.svg'
import CheckFalse from '../../assets/checkFalse.svg'
import CheckWarning from '../../assets/checkWarning.svg'

const RemediationPopup = ({ onClose, description, selectedRow, remediationFunction, formatResultMessage, buttonLabel }) => {
    const [isRemediationLoading, setIsRemediationLoading] = useState(false);
    const [remediationResults, setRemediationResults] = useState({});
    const [isSummaryResultVisible, setIsSummaryResultVisible] = useState(false);
    
    // Cette fonction empêche la popup de se fermer si on clique à l'intérieur
    const handleContainerClick = (e) => e.stopPropagation();

    const handleConfirmRemediation = async () => {
        setIsRemediationLoading(true);
        
        const userIds = selectedRow.map((row) => {
            return {
                "objectId": row.objectId,
                "groupsId": row.groupsId?.map((group) => group.objectId)
            }
        });

        try {
            const controller = new AbortController();
            const signal = controller.signal;

            const response = await remediationFunction(signal, userIds);

            const resultsMap = {};

            response.success?.forEach(element => {
                resultsMap[element.objectId] = {
                    status: 'success',
                    ...formatResultMessage(element, 'success')
                };
            });

            response.failed?.forEach(element => {
                resultsMap[element.objectId] = {
                    status: 'failed',
                    message: element.reason
                };
            });
            
            setRemediationResults(resultsMap);
        } catch (error) {
            console.error("Failed to start remediation process.", error);
        } finally {
            setIsRemediationLoading(false);
        }
    };

    return (
        <PopupOverlay>
            <PopupContainer onClick={handleContainerClick}>
                <CloseButton onClick={onClose}>&times;</CloseButton>
                <PopupHeader>
                    <h2>Start Remediation</h2>
                </PopupHeader>
                <PopupBody>
                    <p>Vous êtes sur le point de démarrer une remédiation.</p>
                    <p><u>Quelques informations sur cette remédiation :</u></p>
                    <p>{description}</p>
                    {
                        Array.isArray(selectedRow) && selectedRow.map((row, index) => {
                            const result = remediationResults[row.objectId]
                            return (
                                <PSelectedRow key={index}>{row.displayName} {result?.status ? (result?.status === "success" ? (result?.verified ? <img src={CheckTrue} alt="success" /> : <img src={CheckWarning} alt="warning" />) : <img src={CheckFalse} alt="failed" />) : null}</PSelectedRow>
                            )
                        })
                    }
                    {Object.keys(remediationResults).length > 0 && (
                        <DivSummaryResult>
                            <SummaryHeader onClick={() => setIsSummaryResultVisible(!isSummaryResultVisible)}>
                                <h5>Result summary</h5>
                                <i className={(isSummaryResultVisible ? "bx bx-chevrons-up" : "bx bx-chevrons-down")}></i>
                            </SummaryHeader>
                            <DivResultContent visible={isSummaryResultVisible}>
                                {Object.entries(remediationResults).map(([objectId, result]) => {
                                    const user = selectedRow.find(r => r.objectId === objectId);
                                    console.log(result);
                                    
                                    return (
                                        <SpanResultLine key={objectId} status={result.status} verified={result.verified}>
                                            <UserInfoColumn>
                                                <strong>{user?.displayName || objectId}</strong>
                                                {/* 👇 AFFICHER L'ERREUR SI FAILED */}
                                                {result.status === 'failed' && (
                                                    <ErrorMessage>{result.message}</ErrorMessage>
                                                )}
                                                {/* 👇 AFFICHER LES WARNINGS SI PRÉSENTS */}
                                                {result.warnings && result.warnings.length > 0 && (
                                                    <CommentList>
                                                        {result.warnings.map((warning, idx) => (
                                                            <li key={idx}>{warning}</li>
                                                        ))}
                                                    </CommentList>
                                                )}
                                                {/* 👇 AFFICHER LES RESULTATS SI PRÉSENTS */}
                                                {result.result && (
                                                    <CommentList>
                                                        {Array.isArray(result.result) ? (
                                                            result.result.map((msg, idx) => (
                                                                <li key={idx}>{msg}</li>
                                                            ))
                                                        ) : (
                                                            <li>{result.result}</li>
                                                        )}
                                                    </CommentList>
                                                )}
                                            </UserInfoColumn>
                                            <StatusBadge status={result.status}>
                                                {result.status === 'success' ? (result.verified ? '✅' : '⚠️') : '❌'}
                                            </StatusBadge>
                                        </SpanResultLine>
                                    );
                                })}
                            </DivResultContent>
                        </DivSummaryResult>
                    )}
                </PopupBody>
                <PopupFooter>
                    { isRemediationLoading ? (
                        <DivLoaderContainer className="loader-container">
                            <DivSpinner className="spinner"/>
                        </DivLoaderContainer>
                    ) : (
                        <>
                            <Button className="secondary" onClick={onClose}>Cancel</Button>
                            <Button className="primary" onClick={handleConfirmRemediation}>{buttonLabel}</Button>
                        </>
                    )}
                </PopupFooter>
            </PopupContainer>
        </PopupOverlay>
  );
};

export default RemediationPopup;